export class MissingApiClientError extends Error {
  constructor() {
    super('API axios instance is not registered. Call registerApiAxiosInstance first.');
    this.name = 'MissingApiClientError';
  }
}

export class MissingNodeApiClientError extends Error {
  constructor() {
    super('Node API axios instance is not registered. Call registerNodeApiAxiosInstance first.');
    this.name = 'MissingNodeApiClientError';
  }
}
